import { ChallengeWithUser } from '../models';
import { ChallengeRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetChallengesReceivedUseCase {
  constructor(private challengeRepository: ChallengeRepository) {}

  async execute(userId: string, limit?: number, offset?: number): Promise<ChallengeWithUser[]> {
    logger.debug('GetChallengesReceived', 'Fetching challenges received', { userId });

    const challenges = await this.challengeRepository.getChallengesReceived(userId, limit, offset);

    logger.debug('GetChallengesReceived', 'Found challenges', { count: challenges.length });

    return challenges;
  }
}
